import type { MakeStylesHook, StyleRules } from '@egr/xbox/utils/tss-react';
import type { Theme } from '@mui/material/styles';
import type * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';

import logo from '../../images/logo25.svg';
import { DebugFiles } from '../DebugFiles';
import { MenuIconWithDrawer } from '../MenuIconWithDrawer';

import { AppBarButtons } from './AppBarButtons/AppBarButtons';

import { safeArea } from '@egr/xbox/egr-gui-elements/Helper/StyleHelper';
import { layoutInformation } from '@egr/xbox/utils/Layout';
import { developmentMode, getEnvBoolean } from '@egr/xbox/utils/ReactScriptHelper';
import { makeStyles } from '@egr/xbox/utils/tss-react';

type HeaderClasses = 'titleBar' | 'logo' | 'title';

function styles(theme: Theme): StyleRules<HeaderClasses> {
    return {
        titleBar: {
            flex: 1,
            display: 'flex',
            alignItems: 'center',
        },
        logo: {
            paddingRight: 28,
            cursor: 'pointer',
            color: theme.palette.text.primary,
        },
        title: {
            cursor: 'pointer',
            color: theme.palette.text.primary,
        },
    };
}
const useStyles: MakeStylesHook<HeaderClasses> = makeStyles({ name: 'Header' })(styles);

const toolbarStyle = safeArea('paddingLeft', 'left', 16);

const styleHeader: React.CSSProperties = {
    width: '100%',
    backgroundColor: '#ffffff',
    position: 'relative',
    zIndex: 1300,
};

const Header: React.FC = () => {
    const [, setRenderTrigger] = useState(0);
    const { classes } = useStyles();
    const { smallLayout } = layoutInformation.useState(['smallLayout']);

    const goHome = () => {
        location.href = location.origin + location.pathname;
    };

    const updateComponentUI = () => {
        setRenderTrigger((prev) => prev + 1);
    };

    useEffect(() => {
        window.addEventListener('resize', updateComponentUI);
        window.addEventListener('orientationchange', updateComponentUI);
        document.addEventListener('customfullscreenchange', updateComponentUI);

        return () => {
            window.removeEventListener('resize', updateComponentUI);
            window.removeEventListener('orientationchange', updateComponentUI);
            document.removeEventListener('customfullscreenchange', updateComponentUI);
        };
    }, []);

    return (
        <AppBar
            style={styleHeader}
            sx={{ boxShadow: 0, borderBottom: 1, borderBottomStyle: 'solid', borderBottomColor: 'divider' }}
        >
            <Toolbar sx={toolbarStyle}>
                <div className={classes?.titleBar}>
                    <img
                        src={logo}
                        className={classes?.logo}
                        onClick={goHome}
                    />
                    <Typography
                        variant="h6"
                        className={classes?.title}
                        onClick={goHome}
                    >
                        impress
                    </Typography>
                </div>
                {(developmentMode || getEnvBoolean('DEBUG_FILES', false)) && <DebugFiles />}
                {smallLayout ? <MenuIconWithDrawer /> : <AppBarButtons />}
            </Toolbar>
        </AppBar>
    );
};

export default Header;
